import { ConfirmationModal } from 'modules/ui';
import { SchedulerConstants } from './SchedulerConstants';
import { GROWTH_SCHEDULE_MESSAGE_BUTTON_CLICKED } from '../GrowthSegmentEvents';
import { SchedulerFeatures } from './SchedulerFeatures';
import { ActiveMessagesFeatures } from '../activeMessages/ActiveMessagesFeatures';
export class SchedulerController {
    static $inject = ['$timeout', '$interval', 'ngToast', 'ModalService', 'ApplicationService2', 'LoadingService', 'MessageService', 'DistributionListService', 'GrowthSegmentService', 'SegmentService', 'application', '$translate'];
    constructor($timeout, $interval, ngToast, ModalService, ApplicationService2, LoadingService, MessageService, DistributionListService, GrowthSegmentService, SegmentService, application, $translate) {
        'ngInject';
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.ngToast = ngToast;
        this.ModalService = ModalService;
        this.ApplicationService2 = ApplicationService2;
        this.LoadingService = LoadingService;
        this.MessageService = MessageService;
        this.DistributionListService = DistributionListService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.SegmentService = SegmentService;
        this.application = application;
        this.$translate = $translate;
        this._schedules = [];
        this.skipAux = 0;
        this._canLoadMore = true;
        this.isLoading = false;
        this.canShowDownloadButton = SchedulerFeatures.enableDownloadReportDefaultValue;
        this.sendersDistributionListIdentity = `${application.shortName}+senders@broadcast.msging.net`;
        this._schedules = [];
        this.schedule = {
            message: { to: this.sendersDistributionListIdentity },
        };
        this.showExecuted = false;
        this.distributionLists = [];
        this.loadMore().then(() => this.loadDistributionLists());
        this.$init();
    }
    async $init() {
        try {
            const account = await this.ApplicationService2.getAccount();
            if (account) {
                this.botAccount = account;
            }
            await this.loadDistributionLists();
        }
        catch (err) {
            console.error(err);
        }
        this._schedules.forEach(this._setScheduleTimeout.bind(this));
        this.canShowDownloadButton = await SchedulerFeatures.isEnabledDownloadReport();
        this.setSchedules();
    }
    setSchedules() {
        const schedulesFiltered = this._schedules
            .filter((s) => !s.message?.id.endsWith('-inputexpirationtime') && !this.isMatchingActiveCampaignGuid(s));
        this.schedules = {
            scheduled: schedulesFiltered
                .filter((s) => s.status !== SchedulerConstants.SCHEDULER_STATUS.EXECUTED && s.status !== SchedulerConstants.SCHEDULER_STATUS.CANCELED)
                .sort(this.compareDate),
            executed: schedulesFiltered
                .filter((s) => s.status === SchedulerConstants.SCHEDULER_STATUS.EXECUTED)
                .sort(this.compareDate),
        };
    }
    async toastError(errorNumber) {
        const errorMsg = await this.$translate(`utils.errorMsg.${errorNumber}`);
        this.ngToast.danger(errorMsg);
    }
    async toastSuccess(errorNumber) {
        const successMsg = await this.$translate(`utils.successMsg.${errorNumber}`);
        this.ngToast.success(successMsg);
    }
    disableLoader() {
        return this.isLoading || !this._canLoadMore;
    }
    async checkRedirectsToActiveCampaign() {
        const isHideScheduler = await ActiveMessagesFeatures.isHideScheduler();
        if (isHideScheduler) {
            const redirectUrl = `${window.location.origin}/application/detail/${this.application?.shortName}/growth/activemessages/sendactivemessage`;
            window.location.href = redirectUrl;
        }
    }
    async loadMore() {
        await this.checkRedirectsToActiveCampaign();
        if (this.disableLoader()) {
            return;
        }
        await this.query();
    }
    async query() {
        try {
            this.LoadingService.startLoading();
            this.isLoading = true;
            const { items } = await this.MessageService.getSchedules({
                skip: this.skipAux,
                take: SchedulerConstants.PAGE_SIZE,
            });
            const schedules = items;
            if (items.length < SchedulerConstants.PAGE_SIZE) {
                this._canLoadMore = false;
            }
            const distributionListMessages = await Promise.all(schedules.map((s) => this._getDistributionListMessage(s)));
            for (let i = 0; i < distributionListMessages.length; i++) {
                schedules[i].distributionListMessage =
                    distributionListMessages[i] || {};
            }
            this._schedules = schedules.reduce((arr, curr) => arr.some((item) => item.message.id === curr.message.id)
                ? arr
                : [...arr, curr], this._schedules || []);
            this.setSchedules();
            this.skipAux += SchedulerConstants.PAGE_SIZE;
        }
        catch (err) {
            console.error(err);
            if (err.code !== 67) {
                const errorMessage = await this.$translate('modules.application.detail.growth.scheduler.errorLoadingScheduledMessages');
                this.ngToast.danger(errorMessage);
            }
            this._canLoadMore = false;
        }
        finally {
            this.LoadingService.stopLoading();
            this.isLoading = false;
        }
    }
    async loadDistributionLists() {
        this.LoadingService.startLoading();
        try {
            this.schedule.message.to = this.sendersDistributionListIdentity;
            this.distributionLists.push({
                $label: this.$translate.instant('modules.application.detail.growth.scheduler.allContacts'),
                identity: this.sendersDistributionListIdentity,
            });
            const resultCommand = await this.DistributionListService.getDistributionLists();
            if (resultCommand.items) {
                const items = resultCommand.items;
                const distributionLists = items
                    .filter((l) => l != this.sendersDistributionListIdentity)
                    .map((l) => ({
                    $label: l.split('@')[0].split('.')[0],
                    identity: l,
                }));
                this.distributionLists = this.distributionLists.concat(distributionLists);
            }
        }
        catch (err) {
            console.error(err);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    set showExecuted(showExecuted) {
        this._schedules.forEach((s) => {
            if (s.status === SchedulerConstants.SCHEDULER_STATUS.JUST_EXECUTED) {
                s.status = SchedulerConstants.SCHEDULER_STATUS.EXECUTED;
            }
        });
        this._showExecuted = showExecuted;
    }
    get showExecuted() {
        return this._showExecuted;
    }
    compareDate(a, b) {
        const dateA = new Date(a.when);
        const dateB = new Date(b.when);
        if (dateA < dateB) {
            return 1;
        }
        if (dateA > dateB) {
            return -1;
        }
        return 0;
    }
    async _getDistributionListMessage(schedule) {
        if (!schedule.message.to) {
            return undefined;
        }
        if ((schedule.status === SchedulerConstants.SCHEDULER_STATUS.EXECUTED ||
            schedule.status === SchedulerConstants.SCHEDULER_STATUS.JUST_EXECUTED) &&
            schedule.message.to.includes(SchedulerConstants.BROADCAST_DOMAIN)) {
            try {
                const getDistributionListMessage = async () => await this.DistributionListService.getDistributionListMessage(schedule.message.to, schedule.message.id);
                const distributionListMessage = await getDistributionListMessage();
                distributionListMessage.getSelf = getDistributionListMessage;
                return distributionListMessage;
            }
            catch (err) {
                if (err.code !== 67) {
                    const errorMessage = await this.$translate('modules.application.detail.growth.scheduler.errorLoadingMessageInformation');
                    this.ngToast.danger(errorMessage);
                }
            }
        }
        return undefined;
    }
    async confirmDelete(schedule) {
        const modalTitle = await this.$translate('modules.application.detail.growth.scheduler.delete.title');
        const modalBody = await this.$translate('modules.application.detail.growth.scheduler.delete.body');
        const yes = await this.$translate('utils.misc.yes');
        const no = await this.$translate('utils.misc.no');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: modalTitle,
            },
            body: modalBody,
            buttons: {
                confirm: {
                    text: yes,
                },
                cancel: {
                    text: no,
                },
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            this._deleteSchedule(schedule);
        }
    }
    async _deleteSchedule(schedule) {
        this.LoadingService.startLoading();
        const index = this._findScheduleIndex(schedule);
        try {
            await this.MessageService.deleteSchedule(schedule);
            this._schedules.splice(index, 1);
            const toastMessage = await this.$translate('modules.application.detail.growth.scheduler.messageDeleted');
            this.ngToast.success(toastMessage);
        }
        catch (err) {
            const errorMessage = await this.$translate('modules.application.detail.growth.scheduler.errorDeletingMessage');
            this.ngToast.danger(errorMessage);
            throw err;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async _scheduleMessage(schedule) {
        await this.MessageService.setSchedule(schedule);
        schedule.status = SchedulerConstants.SCHEDULER_STATUS.SCHEDULED;
        this._createCheckStatusInterval(schedule);
        const toastMessage = await this.$translate('modules.application.detail.growth.scheduler.messageScheduled');
        this.ngToast.success(toastMessage);
    }
    _insertSchedule(schedule) {
        for (const i in this._schedules) {
            if (new Date(schedule.when) < new Date(this._schedules[i].when)) {
                this._schedules.splice(+i, 0, schedule);
                return;
            }
        }
        this._schedules.push(schedule);
    }
    _setScheduleTimeout(schedule) {
        if (schedule.status !== SchedulerConstants.SCHEDULER_STATUS.SCHEDULED) {
            return;
        }
        const timeout = +new Date(schedule.when) - +new Date();
        this.$timeout.cancel(schedule.timeout);
        if (timeout > 0) {
            schedule.timeout = this.$timeout(() => this._createCheckStatusInterval(schedule), timeout);
        }
    }
    async _createCheckStatusInterval(schedule) {
        const interval = this.$interval(async () => {
            const { status, message } = await this.MessageService.getSchedule({ id: schedule.message.id });
            schedule.status =
                status === SchedulerConstants.SCHEDULER_STATUS.EXECUTED ? SchedulerConstants.SCHEDULER_STATUS.JUST_EXECUTED : schedule.status;
            schedule.message = message;
            schedule.distributionListMessage = await this._getDistributionListMessage(schedule);
            this.$interval.cancel(interval);
        }, SchedulerConstants.CHECK_SCHEDULE_STATUS_INTERVAL);
    }
    _findScheduleIndex(schedule) {
        return this._schedules.reduce((index, s, i) => {
            return s.message.id === schedule.message.id ? i : index;
        }, undefined);
    }
    async trackScheduleMessageButtonClicked() {
        this.SegmentService.createApplicationTrack({
            trackEvent: GROWTH_SCHEDULE_MESSAGE_BUTTON_CLICKED,
            application: this.application,
        });
    }
    isMatchingActiveCampaignGuid(item) {
        const regex = /^(activecampaign)\:(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        return regex.test(item.name);
    }
}
SchedulerController.$inject = ['$timeout', '$interval', 'ngToast', 'ModalService', 'ApplicationService2', 'LoadingService', 'MessageService', 'DistributionListService', 'GrowthSegmentService', 'SegmentService', 'application', '$translate'];
